"use strict";
/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */
/** @author Michael Yoon */
Object.defineProperty(exports, "__esModule", { value: true });
function clone(x) {
    if (x == null || typeof x !== 'object') {
        return x;
    }
    if (Array.isArray(x)) {
        return cloneArray(x);
    }
    return cloneObject(x);
}
exports.clone = clone;
function cloneArray(x) {
    var l = x.length;
    var y = new Array(l);
    for (var i = 0; i < l; ++i) {
        y[i] = clone(x[i]);
    }
    return y;
}
function cloneObject(x) {
    var keys = Object.keys(x);
    var y = {};
    for (var k = void 0, i = 0, l = keys.length; i < l; ++i) {
        k = keys[i];
        y[k] = clone(x[k]);
    }
    return y;
}
